<template>
    <div class="chat-attendance-products-component">
        <vs-popup title="" 
            :button-close-hidden="true" 
            :active.sync="isActive" 
            @close="closePopUp"
            style="border-radius: 10px !important;"
            id="popUpProductsChat"
            @search="searchFilter"
            :sst="true"
            >
            <div>
                <span id="display-span-products">
                    <vs-icon
                        v-if="backIsVisible && !updatePreOrder"
                        @click="isCreateContext === false ? $emit('backToOrderSummary', 'product') : $emit('backToCustomerDocument', { backIsVisible: false })"
                        icon="keyboard_arrow_left"
                        style="border: solid 1px; border-radius: 14px; cursor: pointer;"
                    />

                    <p class="ml-6" style="font-size: 16px;" v-if="!isCreateContext || !hasServicesFeature">
                      Produtos
                    </p>

                    <div slot="header" class="" v-if="isCreateContext">

                        <vs-dropdown vs-trigger-click style="cursor:pointer;" v-if="hasServicesFeature">
                            <vs-button
                                class="btn-drop px-3 attendance-span mr-4 erp-drop pl-4"
                                icon="expand_more"
                                icon-after
                                style="border-radius: 22px;"
                            >
                                <span style="font-size:14px;">
                                    {{ this.serviceIsSelected === true ? 'Serviços' : 'Produtos' }}
                                </span>
                            </vs-button>

                            <vs-dropdown-menu class="erp-drop-menu text-center">
                                <vs-dropdown-item class="erp-drop-item" @click="switchToProducts()" @touchstart.prevent="switchToProducts()">
                                    <span> Produtos </span>
                                </vs-dropdown-item>

                                <vs-dropdown-item class="erp-drop-item" @click="switchToServices()" @touchstart.prevent="switchToServices()">
                                    <span> Serviços </span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <vs-dropdown v-if="hasErpFeature && !serviceIsSelected && !updatePreOrder" vs-trigger-click style="cursor:pointer;">
                            <vs-button
                            class="btn-drop px-3 attendance-span mr-4 erp-drop pl-4"
                            icon="expand_more"
                            icon-after
                            style="border-radius: 22px;"
                            >
                            <span style="font-size:14px;">
                                {{ this.erp.name }}
                            </span>
                            
                            </vs-button>
                        
                            <vs-dropdown-menu class="erp-drop-menu text-center">
                                
                                <vs-dropdown-item class="erp-drop-item" @click="changeErpName('Selecione o ERP', null, null)" @touchstart.prevent="changeErpName('Selecione o ERP', null, null)">
                                    <span>Não Vinculados</span>
                                </vs-dropdown-item>
                                
                                <vs-dropdown-item v-for="erp in erpList" class="erp-drop-item" @click="changeErpName(erp.corporate_name, erp.id, erp.erp_id)" @touchstart.prevent="changeErpName(erp.corporate_name, erp.id, erp.erp_id)">
                                    <span>{{ erp.corporate_name }}</span>
                                </vs-dropdown-item>

                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>

                    <div class="flex-end-align">
                        <vs-icon @click="closePopUp" class="mr-2" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right;"></vs-icon>
                    </div>
                </span>
            </div>

            <div>
                <ServiceTable
                    v-if="serviceIsSelected === true"
                    ref="serviceTable"
                />

                <vs-table
                    v-else
                    ref="table" 
                    :data="productsList"
                    @search="searchFilter"
                    @sort="sortFilter"
                    noDataText="Sem dados disponíveis"
                    :sst="true"
                    id="tableDataOfProducts"
                    search
                    :max-items="itemsPerPage"
                    style="padding: 0 !important;"
                >
                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                        <vs-dropdown
                            vs-trigger-click
                            class="cursor-pointer mr-4"
                        >
                            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">                                
                                    {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                                    {{
                                        productsList.length - currentPage * itemsPerPage > 0
                                            ? currentPage * itemsPerPage
                                            : productsList.length
                                    }} de {{ queriedItems }}
                                </span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="itemsPerPage=4" @touchstart.prevent="4">
                                    <span>4</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPage=10" @touchstart.prevent="10">
                                    <span>10</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPage=15" @touchstart.prevent="15">
                                    <span>15</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPage=20" @touchstart.prevent="20">
                                    <span>20</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>

                    <template slot="thead">
                        <vs-th class="text-base">
                            <vs-checkbox
                                class="pl-4"
                                :value="allProductsAreSelected"
                                @click.stop="selectAllProducts()"
                                @touchstart.stop="selectAllProducts()"
                            />
                        </vs-th>
                        <vs-th class="text-base">
                            Imagem
                        </vs-th>
                        <vs-th class="text-base" sort-key="name">
                            Nome
                        </vs-th>
                        <vs-th class="text-base" sort-key="bar_code">
                            Código
                        </vs-th>
                        <vs-th class="text-base" sort-key="laboratory">
                           Laboratório
                        </vs-th>
                        <vs-th class="text-base" sort-key="price">
                            Preço
                        </vs-th>
                       <vs-th class="text-base" sort-key="amount" v-if="hasErpFeature">
                           Estoque
                       </vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <tbody>
                            <vs-tr 
                                :data="tr" 
                                :key="tr.id"
                                :id="tr.id"
                                v-for="(tr, index) in productsList"
                                ref="trProduct"
                                :class="tr.selected ? 'is-selected' : 'selected'"
                            >
                                <vs-td @click.native="selectProduct(tr)" @touchstart.native="selectProduct(tr)">
                                    <vs-checkbox :value="tr.selected"/>
                                </vs-td>

                                <vs-td :data="tr.image" @click.native="selectProduct(tr)" @touchstart.native="selectProduct(tr)">
                                    <div class="d-flex flex-row items-center justify-around"> <!-- justify-evenly -->
                                      <img v-if="tr.image !== undefined && tr.image !== '' && tr.image != null" :src="tr.image" style="width: 50px !important; height: 50px !important;">
                                      <img v-else src="@/assets/images/products/product_without_photo.png" style="width: 40px !important; height: 40px !important;">
                                    </div>
                                </vs-td>

                                <vs-td :data="tr.name" @click.native="selectProduct(tr)" @touchstart.native="selectProduct(tr)">
                                    <div class="d-flex flex-row items-center justify-around"> <!-- justify-evenly -->
                                        <p class="text-center">
                                            {{ tr.name }}
                                        </p>
                                    </div>
                                </vs-td>

                                <vs-td :data="tr.bar_code" @click.native="selectProduct(tr)" @touchstart.native="selectProduct(tr)">
                                    <div class="d-flex flex-row items-center justify-around"> <!-- justify-evenly -->
                                        <p class="text-center">
                                            {{ tr.bar_code }}
                                        </p>
                                    </div>
                                </vs-td>

                                <vs-td :data="tr.laboratory" class="text-center p-1" @click.native="selectProduct(tr)" @touchstart.native="selectProduct(tr)">
                                    {{ tr.laboratory ? tr.laboratory : '-' }}
                                </vs-td>

                                <vs-td :data="tr.price" @click.native="selectProduct(tr)" @touchstart.native="selectProduct(tr)">
                                    <p class="text-center">
                                        <strong>R$ {{ String(tr.price).replace('.', ',') }}</strong>
                                    </p>
                                </vs-td>

                               <vs-td 
                                    v-if="tr.integration_id !== null && hasErpFeature" 
                                    :data="tr.amount" 
                                    class="text-center" 
                                    @click.native="selectProduct(tr)"
                                    @touchstart.native="selectProduct(tr)"
                                >
                                   <p class="text-center">
                                       Qtde <strong>
                                            <span style="color: #1196e1; font-size: 16px;">{{ tr.amount }}</span>
                                        </strong>
                                   </p>
                               </vs-td>

                                <vs-td 
                                  v-else-if="hasErpFeature" 
                                  :data="tr.amount" 
                                  class="text-center" 
                                  @click.native="selectProduct(tr)"
                                  @touchstart.native="selectProduct(tr)"
                                >
                                    <vs-chip id="warn" color="warning">
                                        <feather-icon @mouseenter="alertStock()" feather-icon icon="HelpCircleIcon"></feather-icon>
                                    </vs-chip>
                               </vs-td>
                            </vs-tr>
                        </tbody>
                    </template>
                    
                </vs-table>

                <div class="mt-3 mr-4" v-if="serviceIsSelected === false">
                    <vs-pagination
                        :max="7"
                        :total="totalPages"
                        v-model="page"
                    />
                </div>

                <vs-button @click="checkIfProductsIsEmpty" class="btn-drop px-3 mr-5 mt-2" type="filled" icon="keyboard_arrow_right" icon-after style="float: right !important; border-radius: 12px;">
                    {{ this.isCreateContext ? 'Gerar orçamento' : 'Atualizar Produtos'}}
                </vs-button>
                <br> <br>

            </div>
        </vs-popup>
    </div>
</template>

<script>
    import moduleProduct from "@/store/product/moduleProduct";
    import { hasFeature } from "@/utils";
    import Product from '@/http/requests/product';
    import ERP from '@/http/requests/erp';
    import ErpModal from "../../orders/products/ErpModal.vue";
    import VsDropdown from "@/components/vs-dropdown/dropdown.vue";
    import VsDropdownMenu from "@/components/vs-dropdown/dropdown-menu.vue";
    import VsDropdownItem from "@/components/vs-dropdown/dropdown-item.vue";
    import ServiceTable from '@/views/orders/services/Services.vue';

    export default {

        name: 'ProductsPopUp',
        components: {
            VsDropdown,
            VsDropdownMenu,
            VsDropdownItem,
            ErpModal,
            ServiceTable
        },
        data() {
            return {
                productsList: [],
                search: '',
                selectedProducts: [],
                orderBy: {
                    name: 'name',
                    type: 'ASC'
                },
                page: 1,
                itemsPerPage: 4,
                isMounted: false,
                hasErpFeature: false,
                erp: {
                    id: null,
                    name: '',
                    erp_id: null
                },
                sendToaddQuantity: true,
                serviceIsSelected: false,
                selectedServices: [],
                erpList: [],
                currentPage: 1,
                medicationOptionIsDisabled: false,
                hasServicesFeature: false,
                allProductsAreSelected: false,
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            dataOfProductsToPreOrder: {
                type: Array|Object,
                required: true
            },
            backIsVisible: {
                type: Boolean,
                required: true
            },
            isCreateContext: {
                type: Boolean,
                required: true
            },
            dataToUpdate: {
                type: Array|Object,
                required: true
            },
            outOfChat: {
                type: Boolean,
                default: false
            },
            updatePreOrder: {
                type: Boolean,
                default: false
            },
        },
        emits: [
            'isActiveFalse',
            'backToCustomerDocument',
            'addQuantity',
            'backToOrderSummary'
        ],
        computed: {
            totalPages() {
                return this.$store.state.product.products.total_pages
            },
            queriedItems() {
                return this.$store.state.product && this.$store.state.product.products.total_items
                    ? this.$store.state.product.products.total_items
                    : 0
            },
            totalPages() {
                return this.$store.state.product && this.$store.state.product.products.total_pages
                    ? this.$store.state.product.products.total_pages
                    : 0
            },
        },
        methods: {
            async sortFilter(sortName) {
                if (sortName !== null) {
                    if (sortName !== this.orderBy.name) {
                        this.orderBy.name = sortName;
                        this.orderBy.type = 'ASC';
                    } else if (this.orderBy.type !== "" && this.orderBy.type === "ASC") {
                        this.orderBy.type = 'DESC';
                    } else if (this.orderBy.name === sortName && this.orderBy.type === "DESC") {
                        this.orderBy.name = 'name';
                        this.orderBy.type = 'ASC';
                    }
                    this.page = 1
                    await this.dataLoad();
                    
                }
            },
            async dataLoad() {
                this.hasErpFeature = await hasFeature('erps');

                if (!moduleProduct.isRegistered) {
                    this.$store.registerModule('product', moduleProduct)
                    moduleProduct.isRegistered = true
                }

                if (this.hasErpFeature) {
                    await ERP.fetch()
                    .then((response) => {
                        this.erpList = response.data.data.getErp
                    })
                }

                await this.$store.dispatch("product/fetch", {
                    word: this.search !== '' ? this.search : null,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage,
                    sortName: this.orderBy.name,
                    orderBy: this.orderBy.type,
                    erpId: this.erp.id,
                    hideNeedPrescription: this.medicationOptionIsDisabled == 0 ? false : true
                })

                this.productsList = await this.$store.state.product.products.items;
                
                if (this.selectedProducts.length > 0) {
                    await this.productsList.forEach(product => {
                        if (product.selected === undefined) {
                            product.selected = false;
                        }

                        const isSelected = this.selectedProducts.some(selectedProduct => selectedProduct.id === product.id);

                        product.selected = isSelected;
                    });
                }
                this.checkProductsAreSelected();
                this.$vs.loading.close('#app > .con-vs-loading');
            },
            closePopUp() {
                this.isActive = false;
                this.$emit('isActiveFalse');
            },
            async searchFilter(searchQuery) {
                this.page = 1
                this.search = searchQuery;
                await this.dataLoad();
                
                this.$forceUpdate();
            },
            async checkIfProductsIsEmpty() {
                if (this.serviceIsSelected) {
                    this.switchToProducts();
                }

                if (this.selectedProducts.length === 0 && this.selectedServices.length === 0) {
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Aviso:',
                        time: 5000,
                        text: 'Você precisa escolher pelo menos um produto ou serviço para gerar um orçamento!'
                    });
                }
                
                this.selectedProducts.erpId = this.erp.id
                
                // o numero 1 é o id da trier
                // o numero 2 é o id da alpha7
                if (this.erp.id !== null && this.selectedProducts.length > 0 && (this.erp.erp_id === 1 || this.erp.erp_id === 2)) {
                    this.$vs.loading({
                        type: 'radius',
                        container: '#app',
                        text:  'Estamos verificando o estoque com o ERP. O tempo pode variar de acordo com a quantidade de produtos...',
                        clickEffect: true,
                        background: '#B3DEFF'
                    });

                    await this.updateProductsDiscountAndAmount()
                    if (this.selectedProducts.length === 0) {
                        this.$vs.loading.close('#app > .con-vs-loading');
                        await this.dataLoad();
                        return;
                    }
                } 
                else {
                    this.selectedProducts.forEach(item => {
                        item.quantity = parseInt(1);
                        item.discount_price = item.discount_price === 0.0 ? item.price : item.discount_price
                        item.discount_percentage = 100.0
                    });
                }
                
                if(this.updatePreOrder) {
                    this.selectedProducts.forEach(item => {
                        let match = this.dataOfProductsToPreOrder.product.find(element => element.id === item.id);

                        item.quantity = match ? match.quantity : 1

                        item.discount_price = item.discount_price === 0.0 ? item.price : item.discount_price
                    });
                }

                if (this.sendToaddQuantity) {
                    this.$emit('addQuantity', this.selectedProducts, this.dataToUpdate, this.selectedServices);
                } else {
                    this.$vs.dialog({
                        color: 'primary',
                        title: `Atenção!`,
                        text: 'O ERP deve estar offline, pois não foi possível fazer a requisição ' +
                              'ao mesmo Por favor, verifique se o ERP está funcionando corretamente.',
                        accept: () => this.sendToaddQuantity = true,
                        acceptText: 'Entendi',
                    })
                    this.$vs.loading.close('#app > .con-vs-loading');
                }
                
            },
            alertStock() {
                let color = `#fc9e46`
                this.$vs.notify({
                    title:'Aviso!',
                    text:'Controle de estoque disponível somente para produtos integrados com o Sistema ERP.',
                    color:color,
                })
            },
            async updateProductsDiscountAndAmount() {
                
                const timeoutPromise = new Promise((resolve, reject) => {
                    setTimeout(() => {
                        reject(new Error("Request time limit exceeded"));
                    }, 10000);
                });

                let check = this.selectedProducts.map(item => item.integration_id);

                try {
                    await Promise.race([
                        Product.updateProductErpInfos(check, this.erp.id),
                        timeoutPromise
                    ]).then(response => {
                        this.sendToaddQuantity = true;

                        const productsUpdated = response.data.data.updateProductErpInfos.items;

                        this.selectedProducts.forEach(product => {
                            const updatedItem = productsUpdated.find(item => item.id === product.id);
                            if (updatedItem) {
                                product.amount = updatedItem.amount;
                                product.discount_price = updatedItem.discount_price;
                                product.discount_percentage = updatedItem.discount_percentage;
                            }
                        });
                    })
                    .catch((error) => {
                        console.log(error)
                        if (!(error.message && error.message.includes("Request time limit exceeded"))) {
                            this.selectedProducts = []
                        }
                    });
                } catch (error) {

                    let errorString = error.response.data.errors[0].message;

                    if (
                        errorString === 'A aplicacao da farmácia não esta aceitando conexoes (O SGF pode estar desligado)'
                    ) {
                        this.sendToaddQuantity = false;
                        return;
                    }
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Atenção',
                        time: 8000,
                        text: 'Não conseguimos verificar a quantidade dos produtos devido a problemas de conexão com o ERP. Por favor, verifique sua internet e tente novamente.'
                    });
                }
            },
            hasDuplicate(arr) {
                const hasDuplicate = arr.reduce((acc, obj) => {
                    if (acc.includes(obj.id)) {
                        return true;
                    }
                    acc.push(obj.id);
                    return acc;
                }, []);

                if (typeof hasDuplicate === 'boolean') {
                    return true;
                } 
                return false;
            },
            findDuplicateId(arr) {
                const seenIds = {};
                for (const { id } of arr) {
                    if (seenIds[id]) {
                        return id;
                    } else {
                        seenIds[id] = true;
                    }
                }
                return null;
            },
            executeClickInElementById(id, arr) {
                arr.forEach((item) => {
                    if (item.$attrs.id === id) {
                        item.$el.click();
                    }
                });
            },
            removeObjectFromArrayById(id, arr) {
                var index = arr.findIndex(value => value.id === id);
                arr.splice(index, 1);
            },
            handleListERPs(list) {
                this.erpList = list;
                this.$forceUpdate();
            },
            changeErpName(name, erpId, erpPartnerId) {
                this.erpId = erpId;
                this.erp = {
                    id: erpId,
                    name: name,
                    erp_id: erpPartnerId
                }
            },
            switchToProducts() {
                this.selectedServices = this.$refs.serviceTable._data.selectedServices;
                this.serviceIsSelected = false;
            },
            switchToServices() {
                this.serviceIsSelected = true;

                setTimeout(() => {
                    this.$refs.serviceTable._data.selected = this.selectedServices;
                    this.$refs.serviceTable.trStyleHandler();
                }, 500);
            },
            selectProduct(product) {
                product.selected = !product.selected
                
                if (product.selected) {
                        this.selectedProducts.push(product);
                } 
                else {
                    const index = this.selectedProducts.findIndex(item => item.id === product.id);
                    if (index !== -1) {
                        this.selectedProducts.splice(index, 1);
                    }
                }

                this.checkProductsAreSelected();
                this.$forceUpdate();
            },
            async selectAllProducts() {
                if (this.allProductsAreSelected) {
                    this.productsList.forEach(product => {
                        product.selected = false;
                        const index = this.selectedProducts.findIndex(selectedProduct => selectedProduct.id === product.id);
                        if (index !== -1) {
                            this.selectedProducts.splice(index, 1);
                        }
                    });
                } else {
                    await this.productsList.forEach(product => {
                        if (!product.selected) {
                            product.selected = true;
                            this.selectedProducts.push(product);
                        }
                    });
                }
                this.checkProductsAreSelected();
                this.$forceUpdate();
            },
            checkProductsAreSelected() {
                this.allProductsAreSelected = this.productsList.every(product => product.selected);
            },
        },
        watch: {
            async 'page'() {
                await this.dataLoad()
                this.$forceUpdate();
            },
            'itemsPerPage'() {
                this.page = 1
                this.dataLoad()
            },
            'totalPages'() {
                this.currentPage = 1;
                this.page = 1
            },
            'erp.id': {
                async handler(newVal) {
                    this.erp.id = newVal
                    await this.dataLoad()
                    this.selectedProducts = []
                },
                immediate: true
            },
            'isCreateContext': {
                handler() {
                    if (!this.isCreateContext) {
                        this.erp.id = this.dataToUpdate.data.erp_id
                        if (this.erp.id === null) {
                            this.selectedProducts = []
                        }
                    }
                }
            },
            'isActive': {
                async handler(val) {
                    if (val) {
                        this.$refs.table.searchx = ''
                        this.$vs.loading({
                            type: 'radius',
                            container: '#app',
                        });
                        await this.dataLoad();


                        if (this.isCreateContext && !this.updatePreOrder) {
                            this.changeErpName('Selecione o ERP', null, null)
                        }

                        if (!val) {
                            this.serviceIsSelected = false;
                        }

                        if (this.erpList.length === 1 && this.isCreateContext) {
                            this.changeErpName(this.erpList[0].corporate_name, this.erpList[0].id, this.erpList[0].erp_id)
                        }

                        if (this.updatePreOrder) {
                            this.erpId = this.dataOfProductsToPreOrder.product.erpId
                        }
                    }
                },
                immediate: true
            }
        },
        async mounted() {
            this.$store.dispatch('setShowLoadingOverlay', false)
            this.hasServicesFeature = await hasFeature('services');

            await this.dataLoad();

            this.isMounted = true;

            this.$events.off('cleanProducts')
            this.$events.on('cleanProducts', ({ file }) => {
                if  ( file === 'Products' ) {
                    this.selectedProducts = [];
                    this.dataToUpdate = [];
                    this.selectedServices = [];
                }
            })
       },
       async created() {
            await this.$store.dispatch('settings/fetch');
            this.medicationOptionIsDisabled = this.$store.state.settings.settings.medications_options_is_disabled;
        },
    }
</script>

<style lang="scss" >
    .chat-attendance-products-component {
      .vs-pagination--ul {
        width: fit-content !important;
      }

      .vs-pagination--li {
        margin-left: 0.5rem;
        margin-right: 0.5rem;
      }
    }

    #warn {
        transform: translateX(4.5em);
        border-radius: 50%;
        width: 2em;
    }

    #popUpProductsChat div.vs-popup {
        .vs-popup--content {
            padding: 15px;
            margin: 0;
        }
        margin: 0;
        border-radius: 18px !important;
        border: solid 1.2px;
        border-color: rgba(18, 17, 17, 0.769);
        width: 800px !important;
        .vs-popup--header {
            background-color: transparent !important;
            .vs-popup--title {
                background-color: transparent !important;
                h3 {
                    background-color: transparent !important;
                }
            }
        }
        header {
            background-color: transparent !important;

        }
    }
    #display-span-products {
        display: flex;
        justify-content: flex-start;
        flex-direction: row;
        align-items: center;
        div {
            padding-left: 14px;
            justify-content: flex-end;
            width: 100%;
            i.vs-icon.notranslate.icon-scale.mr-2.material-icons.null:last-of-type {
                cursor: pointer;
            }
        }

    }
    #tableDataOfProducts {
        .vs-con-tbody.vs-table--tbody {
            background-color: transparent !important;
            border: 0 !important;
        }
        table.vs-table.vs-table--tbody-table {
            border-collapse: separate;
            border-spacing: 0 0.5rem;
            padding: 0 1rem;

        }
        header {
            //float: left;
            align-items: center;
            margin-left: 16px;
            margin-right: 16px;
            div > input {
                border: solid 0.1px !important;
                color: #726f6fb4;
            }
        }
        tbody {
            tr.tr-values.vs-table--tr.tr-table-state-null.is-selected.selected {
                border-radius: 14px !important;
            }
            td {
                padding: 0px;
                border-style: solid;
                border-color: #b6bebd6e;
            }
            td:first-of-type {
                border-top-left-radius: 14px;
                border-bottom-left-radius: 14px;
                border-width: 1px 0px 1px 1px;
            }
            td:last-of-type {
                border-top-right-radius: 14px;
                border-bottom-right-radius: 14px;
                border-width: 1px 1px 1px 0px;
            }
            td {
                border-width: 1px 0px 1px 0px;
            }
        }
    }

    .erp-drop {
        background-color: rgba(0, 0, 0, 0) !important;
        border: 1px solid #0491FF;
    }
    .erp-drop span {
        color:#0491FF;
        font-weight: 500;
    }
    .erp-drop i {
        color: #0491FF;
    }
    .erp-drop-menu {
        width: 12rem !important;
    }
    .erp-drop-item {
        padding: .5rem !important;
        font-size: 14px !important;
    }
    .erp-drop-item span {        
        justify-content: center;
        display: flex;
    }
</style>
